import React, { useEffect, useState, useRef, Children } from 'react';
import { BoxIcon, UsersIcon, FlaskConicalIcon, PlusIcon, FileTextIcon, HomeIcon, ChevronRightIcon, MoreHorizontalIcon, SparklesIcon } from 'lucide-react';
interface ChildPage {
  id: string;
  label: string;
  parentSection: string;
}
interface SidebarProps {
  activeSection: string;
  activePageId: string | null;
  childPages: ChildPage[];
  onSelectSection: (sectionId: string, openInNewTab?: boolean) => void;
  onSelectPage: (pageId: string, openInNewTab?: boolean) => void;
  onAddChildPage: (sectionId: string) => void;
  onDeletePage: (pageId: string) => void;
  onboardingStep?: string | null;
  onRestartOnboarding?: () => void;
}
const SECTIONS = [{
  id: 'home',
  label: 'Home',
  icon: <HomeIcon className="w-4 h-4 flex-shrink-0 text-stone-400" data-id="element-362" />
}, {
  id: 'product-hub',
  label: 'Feature Hub',
  icon: <BoxIcon className="w-4 h-4 flex-shrink-0 text-stone-400" data-id="element-363" />
}, {
  id: 'persona-hub',
  label: 'Persona Hub',
  icon: <svg width="16" height="16" viewBox="0 0 220 218" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 text-stone-400" data-id="element-364">
        <path d="M28 24V29.7856C28 35.7975 29.755 41.6787 33.0498 46.7075C35.967 51.1601 39.9858 54.783 44.716 57.2244L45.5586 57.6593C50.4485 60.1831 55.8713 61.5 61.3741 61.5H62.9638C68.5815 61.5 74.1261 60.2267 79.181 57.7759L80.7331 57.0234C85.4963 54.7139 89.5797 51.2094 92.585 46.8517C96.1115 41.7383 98 35.6736 98 29.4621V24" stroke="currentColor" strokeWidth="10" data-id="element-365" />
        <circle cx="62.5" cy="40.5" r="8.5" fill="currentColor" data-id="element-366" />
        <path d="M24 99L48.8913 96.6066C49.6276 96.5358 50.3523 96.3742 51.0489 96.1254C54.6177 94.8508 57 91.4704 57 87.6808V74.32C57 71.1057 59.6057 68.5 62.82 68.5C64.2256 68.5 65.5838 69.0087 66.6436 69.9322L100 99" stroke="currentColor" strokeWidth="10" data-id="element-367" />
        <path d="M124 99V93.2144C124 87.2025 125.755 81.3213 129.05 76.2925C131.967 71.8399 135.986 68.217 140.716 65.7756L141.559 65.3407C146.448 62.8169 151.871 61.5 157.374 61.5H158.964C164.581 61.5 170.126 62.7733 175.181 65.2241L176.733 65.9766C181.496 68.2861 185.58 71.7906 188.585 76.1483C192.111 81.2617 194 87.3264 194 93.5379V99" stroke="currentColor" strokeWidth="10" data-id="element-368" />
        <circle cx="8.5" cy="8.5" r="8.5" transform="matrix(1 0 0 -1 150 91)" fill="currentColor" data-id="element-369" />
        <path d="M120 24L144.891 26.3934C145.628 26.4642 146.352 26.6258 147.049 26.8746C150.618 28.1492 153 31.5296 153 35.3192V48.68C153 51.8943 155.606 54.5 158.82 54.5C160.226 54.5 161.584 53.9913 162.644 53.0678L196 24" stroke="currentColor" strokeWidth="10" data-id="element-370" />
        <path d="M96 119V124.786C96 130.798 94.245 136.679 90.9502 141.708C88.033 146.16 84.0142 149.783 79.284 152.224L78.4414 152.659C73.5515 155.183 68.1287 156.5 62.6259 156.5H61.0362C55.4185 156.5 49.8739 155.227 44.819 152.776L43.2669 152.023C38.5037 149.714 34.4203 146.209 31.415 141.852C27.8885 136.738 26 130.674 26 124.462V119" stroke="currentColor" strokeWidth="10" data-id="element-371" />
        <circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-1 0 0 1 70 127)" fill="currentColor" data-id="element-372" />
        <path d="M100 194L75.1087 191.607C74.3724 191.536 73.6477 191.374 72.9511 191.125C69.3823 189.851 67 186.47 67 182.681V169.32C67 166.106 64.3943 163.5 61.18 163.5C59.7744 163.5 58.4162 164.009 57.3564 164.932L24 194" stroke="currentColor" strokeWidth="10" data-id="element-373" />
        <path d="M192 194V188.214C192 182.202 190.245 176.321 186.95 171.292C184.033 166.84 180.014 163.217 175.284 160.776L174.441 160.341C169.552 157.817 164.129 156.5 158.626 156.5H157.036C151.419 156.5 145.874 157.773 140.819 160.224L139.267 160.977C134.504 163.286 130.42 166.791 127.415 171.148C123.889 176.262 122 182.326 122 188.538V194" stroke="currentColor" strokeWidth="10" data-id="element-374" />
        <circle cx="157.5" cy="177.5" r="8.5" transform="rotate(-180 157.5 177.5)" fill="currentColor" data-id="element-375" />
        <path d="M196 119L171.109 121.393C170.372 121.464 169.648 121.626 168.951 121.875C165.382 123.149 163 126.53 163 130.319V143.68C163 146.894 160.394 149.5 157.18 149.5C155.774 149.5 154.416 148.991 153.356 148.068L120 119" stroke="currentColor" strokeWidth="10" data-id="element-376" />
      </svg>
}, {
  id: 'tests',
  label: 'Test Hub',
  icon: <FlaskConicalIcon className="w-4 h-4 flex-shrink-0 text-stone-400" data-id="element-377" />
}];
const HUB_SECTIONS = ['product-hub', 'persona-hub', 'tests'];
export function Sidebar({
  activeSection,
  activePageId,
  childPages,
  onSelectSection,
  onSelectPage,
  onAddChildPage,
  onDeletePage,
  onboardingStep,
  onRestartOnboarding
}: SidebarProps) {
  const [isHubsExpanded, setIsHubsExpanded] = useState(false);
  const [showWorkspaceMenu, setShowWorkspaceMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  // Auto-expand Hubs section when a hub page is active or during onboarding
  useEffect(() => {
    if (HUB_SECTIONS.includes(activeSection)) {
      setIsHubsExpanded(true);
    }
  }, [activeSection]);
  // Auto-expand hubs during onboarding steps that reference hub nav items
  useEffect(() => {
    if (onboardingStep === 'feature-hub-nav' || onboardingStep === 'new-feature-button' || onboardingStep === 'feature-template' || onboardingStep === 'persona-hub-nav' || onboardingStep === 'new-persona-button' || onboardingStep === 'persona-template' || onboardingStep === 'test-hub-nav' || onboardingStep === 'new-test-button' || onboardingStep === 'test-template') {
      setIsHubsExpanded(true);
    }
  }, [onboardingStep]);
  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setShowWorkspaceMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <aside className="w-60 flex-shrink-0 bg-stone-50 border-r border-stone-200 flex flex-col h-full select-none" data-id="element-378">
      {/* Branding */}
      <div className="px-3 pt-4 pb-3 border-b border-stone-200" data-id="element-379">
        <img src="https://cdn.magicpatterns.com/uploads/pjTsCkbAC8Z8nUeKngPgTa/Synthetic_Archetype_Logo_Type.svg" alt="Archetype" className="h-[30px] w-auto" data-id="element-380" />
        <div className="flex items-center justify-between gap-2 ml-[0px] mr-[0px] mt-[12px] mb-[0px]" data-id="element-381">
          <p className="text-[11px] text-stone-400 mt-0.5" data-id="element-382">Product Team Name</p>
          <div ref={menuRef} className="relative" data-id="element-383">
            <button type="button" onClick={() => setShowWorkspaceMenu(!showWorkspaceMenu)} className="w-5 h-5 flex items-center justify-center rounded-none hover:bg-stone-200 transition-colors duration-100 text-stone-400 hover:text-stone-600" aria-label="Workspace options" data-id="element-384">
              <MoreHorizontalIcon className="w-3.5 h-3.5" data-id="element-385" />
            </button>
            {showWorkspaceMenu && <div className="absolute left-0 top-full mt-1 z-50 w-56 bg-white border border-stone-200 rounded-none shadow-lg py-1" data-id="element-386">
                <button type="button" onClick={() => {
              setShowWorkspaceMenu(false);
              // No functionality needed per user request
            }} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-stone-600 hover:bg-stone-50 transition-colors duration-100 text-left" data-id="element-387">
                  <span data-id="element-388">Create a new product workspace</span>
                </button>
              </div>}
          </div>
        </div>
      </div>

      {/* Section list */}
      <nav className="flex-1 overflow-y-auto px-2 pt-2 pb-[8px]" aria-label="Sections" data-id="element-389">
        <button type="button" onClick={() => onAddChildPage('tests')} className="w-full flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-white rounded-none hover:bg-[#3333ff] transition-colors duration-100 mt-[12px] mb-[24px] bg-[#0000ff]" data-id="element-390">
          <span data-id="element-391">New Test</span>
          <PlusIcon className="w-3.5 h-3.5" data-id="element-392" />
        </button>

        <ul className="space-y-0.5" data-id="element-393">
          {SECTIONS.map(section => {
          const isHome = section.id === 'home';
          const isHubSection = HUB_SECTIONS.includes(section.id);
          // Skip rendering hub sections here if they're in the Hubs group
          if (isHubSection) return null;
          return <li key={section.id} data-id="element-394">
                <button onClick={e => onSelectSection(section.id, e.metaKey || e.ctrlKey)} className={`${`w-full flex items-center gap-2 px-2 py-1.5 rounded-none text-left text-sm transition-colors duration-100 ${section.id === activeSection ? 'bg-stone-200/70 text-stone-900' : 'text-stone-600 hover:bg-stone-100'}`} mb-[24px]`} aria-current={section.id === activeSection ? 'page' : undefined} data-id="element-395">
                  {section.icon}
                  <span className="flex-1 truncate" data-id="element-396">{section.label}</span>
                </button>
              </li>;
        })}

          {/* Hubs Section */}
          <li className="pt-4 mt-4 border-t border-stone-200" data-id="element-397">
            <button onClick={() => setIsHubsExpanded(!isHubsExpanded)} className="w-full flex items-center gap-2 px-2 py-1.5 rounded-none text-left text-sm transition-colors duration-100 text-stone-600 hover:bg-stone-100" data-id="element-398">
              <span className="flex-1 truncate font-medium" data-id="element-399">Hubs</span>
              <ChevronRightIcon className={`w-4 h-4 flex-shrink-0 text-stone-400 transition-transform duration-150 ${isHubsExpanded ? 'rotate-90' : ''}`} data-id="element-400" />
            </button>

            {isHubsExpanded && <ul className="mt-0.5 space-y-0.5 pl-4" data-id="element-401">
                {SECTIONS.filter(s => HUB_SECTIONS.includes(s.id)).map(section => <li key={section.id} data-id="element-402">
                      <button id={section.id === 'product-hub' ? 'onboarding-feature-hub-nav' : section.id === 'persona-hub' ? 'onboarding-persona-hub-nav' : section.id === 'tests' ? 'onboarding-test-hub-nav' : undefined} onClick={e => onSelectSection(section.id, e.metaKey || e.ctrlKey)} className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-none text-left text-sm transition-colors duration-100 ${section.id === activeSection ? 'bg-stone-200/70 text-stone-900' : 'text-stone-600 hover:bg-stone-100'}`} aria-current={section.id === activeSection ? 'page' : undefined} data-id="element-403">
                        {section.icon}
                        <span className="flex-1 truncate" data-id="element-404">{section.label}</span>
                      </button>
                    </li>)}
              </ul>}
          </li>
        </ul>
      </nav>

      {/* Bottom actions */}
      {onRestartOnboarding && <div className="px-3 py-3 border-t border-stone-200" data-id="element-405">
          <button type="button" onClick={onRestartOnboarding} className="w-full flex items-center gap-1.5 px-2 py-1.5 text-xs text-stone-400 hover:text-stone-600 hover:bg-stone-100 rounded-none transition-colors duration-100 text-left" data-id="element-406">
            <SparklesIcon className="w-3.5 h-3.5 flex-shrink-0" data-id="element-407" />
            <span data-id="element-408">Run Onboarding Flow</span>
          </button>
        </div>}
    </aside>;
}